<template lang="pug">
  .order-detail#order-detail
    .order-info
      .basic-info#basic-info
        .order-main-status {{ orderMainInfo.orderStatus | orderStatusFormat }}
        .flex-g
          .flex
            .basic-info-container
              .amount
                .m-b15
                  span 订单总金额：
                  span.price
                    | {{ orderMainInfo.actualTotalFee | currencyFormat }}
                    zg-info(v-if='orderMainInfo.logisticsTotalFee || orderMainInfo.processTotalFee || orderMainInfo.storageTotalFee || orderMainInfo.commissionTotalFee || orderMainInfo.promiseInterestSubsidyTotalFee || orderMainInfo.settleAdjustTotalFee')
                      div(slot="content")
                        div 商品总金额：{{ orderMainInfo.obligationTotalFee | currencyFormat }}
                        div(v-if='orderMainInfo.logisticsTotalFee') 胖猫物流总金额：{{ orderMainInfo.logisticsTotalFee | currencyFormat }}
                        div(v-if='orderMainInfo.processTotalFee') 加工总金额：{{ orderMainInfo.processTotalFee | currencyFormat }}
                        div(v-if='orderMainInfo.storageTotalFee') 仓储总金额：{{ orderMainInfo.storageTotalFee | currencyFormat }}
                        div(v-if='orderMainInfo.commissionTotalFee') 委托物流总金额：{{ orderMainInfo.commissionTotalFee | currencyFormat }}
                        div(v-if='orderMainInfo.promiseInterestSubsidyTotalFee') 承兑贴息总金额：{{ orderMainInfo.promiseInterestSubsidyTotalFee | currencyFormat }}
                        div(v-if='orderMainInfo.settleAdjustTotalFee') 结算调差总金额：{{ orderMainInfo.settleAdjustTotalFee | currencyFormat }}

                  //el-tag(v-if="orderMainInfo.subBizType === 100" effect="plain" size="small" type="warning" style="padding:2px;line-height:12px;height:17px;border-radius:unset;margin-left:15px;") 先货后款
                .m-b15(v-if="getIsShowActualPaidFee")
                  span 实收款金额：
                  //- span.price.money(v-if="['WAITING_PAY', 'CLOSED', 'CANCEL', 'NO_PAY_WAITING_FINISH', 'NO_PAY_WAITING_DELIVERY', 'NO_PAY_WAITING_SHIPPING'].indexOf(orderMainInfo.orderStatus) > -1") {{ 0 | currencyFormat }}
                  span.price.price-focus {{ getActualPaidFee | currencyFormat }}
                .m-b15(v-if="orderDetail.closeReason")
                  span 取消原因:
                  span {{orderDetail.closeReason}}
            zg-step.p-20(:steps="getSteps(orderMainInfo.orderStatus)" :active="activeStep")
          //- .operations.m-b5.m-l15
          //-   zg-button(type="main" @click="isShowSellerMemo = true" label="添加备注")
          //-   zg-button(type="main" @click="isShowUpdatePrice = true" v-if="orderMainInfo.orderStatus === 'WAITING_PAY'" label="修改价格")
          //-   zg-button(type="main" @click="isShowDelayTime = true" v-if="orderMainInfo.orderStatus === 'WAITING_PAY'" label="延长付款")
            //- zg-button(type="main" @click="goToSign" v-if="!['CLOSED', 'CANCEL'].includes(orderMainInfo.orderStatus) && [CONTRACT_STATUS.INIT.key, CONTRACT_STATUS.SELLER_UNSIGNED.key].includes(orderDetail.detailStatus)  && (orderDetail && orderDetail.orgInfo && !orderDetail.orgInfo.isSelfOrg && orderDetail.bizOrder.createTime > 1577379600000) && orderDetail.bizOrder.subBizType !== 100" label="签署合同")
            //- zg-button(v-if="orderMainInfo.containerFuturesGoods" type="base" @click="viewContractHistory" label="下载合同")
            //- zg-button(v-else type="base" @click="viewContractHistory" label="下载合同" tips="本合同只支持现货交易，不包含预售业务")

            zg-button.copy-pay-info(type="base" :data-clipboard-text="shareLink"
              @click="sharePayInfo" v-if="shareLink && (orderMainInfo.orderStatus === 'WAITING_PAY' || (['NO_PAY_WAITING_FINISH', 'NO_PAY_WAITING_DELIVERY', 'NO_PAY_WAITING_SHIPPING'].indexOf(orderMainInfo.orderStatus) > -1 && orderMainInfo.finacingAmount === 0 && orderMainInfo.finacedAmount === 0))" label="分享支付信息")

      .overview#overview
        module-title.overview-title(title="订单概览")
          //- slot
          //-   .countdown.full-right(v-if="orderDetail.bizOrderPayTimeOut > 0 && orderMainInfo.orderStatus === 'WAITING_PAY'")
          //-     span 剩余付款时间：
          //-     countdown(:end-time="Date.now() + orderDetail.bizOrderPayTimeOut * 1000" @onTimeEnd="onTimeEnd")
        el-row.m-b10
          el-col(:span="4")
            span 买家：
            span {{ orderMainInfo.buyerOrgName }}
          el-col(:span="4")
            span 订单编号：
            span {{ orderMainInfo.bizOrderId }}
          el-col(:span="7")
            span 下单人：
            span {{ orderMainInfo.buyerNick }}
            span(v-if="orderDetail.contactInfo") （{{ orderDetail.contactInfo.phoneNum | phoneFormat }}）
            i.el-icon-chat-dot-square.chat(@click="toChat(orderMainInfo.buyerId)")
          el-col(:span="5")
            span 下单时间：
            span {{ orderMainInfo.createTime | dataFormat }}
        el-row.lh-30
          el-col(:span="4")
            span 订单类型：
            span {{ orderMainInfo.futuresFlag || orderMainInfo.containerFuturesGoods ? '预售': '现货'}}
          el-col.other-info(:span="20")
            span 订单备注：
            span {{ orderDetail.otherInfo || '无' }}
        el-row.lh-30
          el-col.seller-memo(:span="24")
            span 卖家备注：
            span {{ orderDetail.sellerMemo || '无' }}


      .overview#invoice-info
        module-title.overview-title(title="开票信息")
        el-row.m-b10
          el-col(:span="8")
            span 抬头：
            span(v-if="invoiceDetail && invoiceDetail.invoiceOrgName") {{ invoiceDetail.invoiceOrgName }}
            span(v-else) 暂无
          el-col(:span="8")
            span 银行账号：
            span(v-if="invoiceDetail && invoiceDetail.invoiceAccount") {{ invoiceDetail.invoiceAccount }}
            span(v-else) 暂无
          el-col(:span="8")
            span 开票地址：
            span(v-if="invoiceDetail && invoiceDetail.invoiceAddress") {{ invoiceDetail.invoiceAddress }}
            span(v-else) 暂无
        el-row.row
          el-col(:span="8")
            span 纳税号：
            span(v-if="invoiceDetail && invoiceDetail.taxNumber") {{ invoiceDetail.taxNumber }}
            span(v-else) 暂无
          el-col(:span="8")
            span 开户银行：
            span(v-if="invoiceDetail && invoiceDetail.bankOfDeposit") {{ invoiceDetail.bankOfDeposit}}
            span(v-else) 暂无
          el-col(:span="8")
            span 开票电话：
            span(v-if="invoiceDetail && invoiceDetail.phoneNumber") {{ invoiceDetail.phoneNumber }}
            span(v-else) 暂无
        el-row.row
          el-col(:span="8")
            span 开票日期：
            invoice-day-tip(v-if="invoiceDetail" :invoice-cycle="invoiceDetail.invoiceCycle"  :invoice-day="invoiceDetail.invoiceDay" :invoice-trigger="invoiceDetail.invoiceTrigger")

      .overview.test#picket-address
        module-title.overview-title(title="发票邮寄地址")
        .picket-address(v-for="item, index in picketAddressLs" :key="item.id"
          :class="{'p-0': index === 0}")
          //- :class="{'p-0': index === 0}" v-if="isShowAllAddrss || index < 1")
          el-row
            el-col(:span="12")
              span 收件人姓名：
              span {{item.recipientsName}}
            el-col(:span="12")
              span 收件人电话：
              span {{item.recipientsPhone}}
          el-row.row
            el-col(:span="24")
              span 邮寄地址：
              span.lh-14 {{item.province}} {{item.city}} {{item.area}} {{item.detailAddress}}
        //- .show-all(@click="isShowAllAddrss = !isShowAllAddrss" v-if="picketAddressLs && picketAddressLs.length > 1")
        //-   span {{!isShowAllAddrss ? '展开' : '收起'}}
        //-   i(:class="`el-icon-caret-${!isShowAllAddrss ? 'bottom' : 'top'}`")
        .empty-address(v-if="picketAddressLs && picketAddressLs.length === 0") 暂无邮寄地址

      .pay-info#pay-info
        module-title(title="收款明细")
        el-table(:data="payInfoList"  style="width: 99.9%" stripe)
          el-table-column(label="支付流水号" align="center" prop="outTradeNo" width="150")
          el-table-column(label="支付时间" align="center" prop="gmtPayment" :formatter="$tableFormat" width="100")
          el-table-column(label="支付金额" align="center")
            template(slot-scope="scope")
              .goods-piece-weight.c-red {{scope.row.paymentAmount | currencyFormat}}
          el-table-column(label="收款账号" align="center")
            template(slot-scope="scope")
              p {{scope.row.receiverAccountNo || '--'}}
          el-table-column(label="收款银行" align="center")
            template(slot-scope="scope")
              p {{scope.row.receiverBankName || '--'}}
          el-table-column(label="打款账号" align="center")
            template(slot-scope="scope")
              p {{scope.row.payerAccountNo || '--'}}
          el-table-column(label="打款银行" align="center")
            template(slot-scope="scope")
              p {{scope.row.payerBankName || '--'}}
          el-table-column(label="回执单" align="center")
            template(slot-scope="scope")
              el-button(type="text" v-if="scope.row.tradeCertificate" @click="downloadBankReceipt(scope.row.tradeCertificate)") 下载
              p(v-else) --
          el-table-column(label="支付类型" align="center" prop="payChannel")
            template(slot-scope="scope")
              p {{scope.row.payChannel | convertPayChannel}}
          el-table-column(label="备注" align="center" prop="remark")
            template(slot-scope="scope")
              p {{scope.row.remark}}

      .goods-info#goods-info(v-if="getOrderType === 'uncertain'" ref="goodInfo")
        module-title(class="overflow-hidden")
          span(ref="guide2") 不定规格商品明细
          .module-right(v-if="orderMainInfo.orderStatus !== 'WAITING_PAY'")
            el-button(ref="guide1" type="primary" size="small" @click="isShowBatchImport=true" :disabled="!isEnableBatchImport") 批量指认商品
            el-button(ref="guide3" class="btn-record" size="small" @click="$router.push('/order/detailExportRecord/' + orderId)") 导入记录
            el-link.m-l10(:underline="false" type="danger" size="small" icon="el-icon-question" @click="showGuide") 如何批量指认
        uncertain-order-list(ref="uncertainOrderList" :list="suborderList" :is-show-guide="isShowGuide" @refreshData="getOrderDetail")
      .goods-info#goods-info(v-else)
        module-title(title="商品明细")
          div.c-6.m-l70
            span 总计：
            span.c-red.m-l10 数量 {{orderMainInfo.buyAmount}}

            span.c-red.m-l10 {{orderMainInfo.totalWeight | formatWeight}}
            span.m-l5 吨
            span.c-red.m-l15 {{orderMainInfo.actualTotalFee | currencyFormat}}
        el-table(:data="suborderList" ref="table" style="width: 99.9%" stripe)
          el-table-column(label="商品" align="left" min-width="120px")
            template(slot-scope="scope")
              .goods-name {{scope.row.itemTitle}}
              .goods-no 商品编号：{{scope.row.itemId}}
              div.goods-no(v-if="scope.row.supplierName") {{scope.row.supplierName}}
              el-tag.m-t10.tag(v-if="scope.row.bizOrder.containerFuturesGoods"
                effect="plain" size="small" type="warning") 预售
          el-table-column(label="商品属性" align="center" min-width="120px")
            template(slot-scope="scope")
              .c-9
                p.sku-title 单件重: &nbsp;
                  span.c-3 {{scope.row.bizOrder.pieceWeight / 10000}}{{ scope.row.bizOrder.pieceWeightUnit | exUnitToWeight}}
                p.sku-title.flex(v-for="(item, index) in scope.row.skuTitleList" :key="index")
                  span {{item.split(':')[0]}}:
                  span.c-3(v-if="item.length < 14") {{item.split(':')[1] || '-'}}
                  el-tooltip.max-len(v-else placement="top" :content="item.split(':')[1]")
                    span {{item.split(':')[1] || '-'}}
                p.sku-title 仓库: &nbsp;
                  span.c-3 {{scope.row.warehouseName}}
          el-table-column(label="单价" align="center")
            template(slot-scope="scope")
              template(v-if="scope.row.bizOrder.logisticsPrice || scope.row.bizOrder.processFee || scope.row.bizOrder.storageFee || scope.row.bizOrder.commissionFee || scope.row.bizOrder.promiseInterestSubsidyFee || scope.row.bizOrder.settleAdjustFee")
                p {{ (scope.row.itemPrice + scope.row.bizOrder.logisticsPrice + scope.row.bizOrder.processFee + scope.row.bizOrder.storageFee + scope.row.bizOrder.commissionFee + scope.row.bizOrder.promiseInterestSubsidyFee + scope.row.bizOrder.settleAdjustFee) / 100 }} 元/{{ scope.row.bizOrder.pieceWeightUnit | formatWeightUnit }}
                zg-info
                  div(slot="content")
                    div 商品单价：{{ scope.row.itemPrice / 100 }} 元/{{ scope.row.bizOrder.pieceWeightUnit | formatWeightUnit }}
                    div(v-if='scope.row.bizOrder.logisticsPrice') 胖猫物流费：{{ scope.row.bizOrder.logisticsPrice / 100 }} 元/{{ scope.row.bizOrder.pieceWeightUnit | formatWeightUnit }}
                    div(v-if='scope.row.bizOrder.processFee') 加工费：{{ scope.row.bizOrder.processFee / 100 }} 元/{{ scope.row.bizOrder.pieceWeightUnit | formatWeightUnit }}
                    div(v-if='scope.row.bizOrder.storageFee') 仓储费：{{ scope.row.bizOrder.storageFee / 100 }} 元/{{ scope.row.bizOrder.pieceWeightUnit | formatWeightUnit }}
                    div(v-if='scope.row.bizOrder.commissionFee') 委托物流费：{{ scope.row.bizOrder.commissionFee / 100 }} 元/{{ scope.row.bizOrder.pieceWeightUnit | formatWeightUnit }}
                    div(v-if='scope.row.bizOrder.promiseInterestSubsidyFee') 承兑贴息费：{{ scope.row.bizOrder.promiseInterestSubsidyFee / 100 }} 元/{{ scope.row.bizOrder.pieceWeightUnit | formatWeightUnit }}
                    div(v-if='scope.row.bizOrder.settleAdjustFee') 结算调差费：{{ scope.row.bizOrder.settleAdjustFee / 100 }} 元/{{ scope.row.bizOrder.pieceWeightUnit | formatWeightUnit }}
              template(v-else)
                p {{ scope.row.itemPrice / 100 }} 元/{{ scope.row.bizOrder.pieceWeightUnit | formatWeightUnit}}

          el-table-column(label="数量" align="center" prop="buyAmount")
          el-table-column(label="重量" align="center")
            template(slot-scope="scope")
              p {{scope.row.bizOrder.totalWeight / 10000}}{{ scope.row.bizOrder.pieceWeightUnit | exUnitToWeight }}
          el-table-column(label="实提数量" align="center")
            template(slot-scope="scope")
              p(v-if="scope.row.lgOrderDispatchItemInfo") {{scope.row.lgOrderDispatchItemInfo.realItemNum}}
          el-table-column(label="实提重量" align="center" prop="lgOrderDispatchItemInfo.realItemWeight")
            template(slot-scope="scope")
              p(v-if="scope.row.lgOrderDispatchItemInfo")
                | {{scope.row.lgOrderDispatchItemInfo.realItemWeight / 10000 || 0}}吨
          el-table-column(label="状态" align="center" prop="orderStatus")
            template(slot-scope="scope")
              .goods-piece-weight {{scope.row.bizOrder.orderStatus | orderStatusFormat}}
          el-table-column(label="实付金额" align="center")
            template(slot-scope="scope")
              .goods-piece-weight.c-red(v-if="['WAITING_PAY', 'CANCEL', 'NO_PAY_WAITING_FINISH', 'NO_PAY_WAITING_DELIVERY', 'NO_PAY_WAITING_SHIPPING'].indexOf(scope.row.bizOrder.orderStatus) === -1")
                template(v-if='scope.row.bizOrder.logisticsTotalFee || scope.row.bizOrder.processTotalFee  || scope.row.bizOrder.storageTotalFee || scope.row.bizOrder.commissionTotalFee || scope.row.bizOrder.promiseInterestSubsidyTotalFee || scope.row.bizOrder.settleAdjustTotalFee')
                  p {{ scope.row.bizOrder.paidAmount | currencyFormat }}
                    zg-info
                      div(slot="content")
                        div 商品金额：{{ scope.row.bizOrder.obligationTotalFee | currencyFormat }}
                        div(v-if='scope.row.bizOrder.logisticsTotalFee ') 胖猫物流金额：{{ scope.row.bizOrder.logisticsTotalFee | currencyFormat }}
                        div(v-if='scope.row.bizOrder.processTotalFee ') 加工费金额：{{ scope.row.bizOrder.processTotalFee | currencyFormat }}
                        div(v-if='scope.row.bizOrder.storageTotalFee ') 仓储费金额：{{ scope.row.bizOrder.storageTotalFee | currencyFormat }}
                        div(v-if='scope.row.bizOrder.commissionTotalFee ') 委托物流金额：{{ scope.row.bizOrder.commissionTotalFee | currencyFormat }}
                        div(v-if='scope.row.bizOrder.promiseInterestSubsidyTotalFee ') 承兑贴息金额：{{ scope.row.bizOrder.promiseInterestSubsidyTotalFee | currencyFormat }}
                        div(v-if='scope.row.bizOrder.settleAdjustTotalFee ') 结算调差金额：{{ scope.row.bizOrder.settleAdjustTotalFee | currencyFormat }}
                template(v-else)
                  p {{ scope.row.bizOrder.paidAmount | currencyFormat }}
          el-table-column(label="操作" align="center" min-width="80px")
            template(slot-scope="scope")
              el-button(type="text" v-if="scope.row.existRefundApply"
                @click="toogleExpand(scope.row)") 退款详情
              el-button(type="text" v-if="scope.row.canUpdateBundleNo" @click="updateBizOrderDetailBundleNo(scope.row)") 修改捆包号

      .pick-info#pick-info
        module-title(title="提货明细")
        picker-section(v-if="pickerList.length > 0" :list="pickerList")
        .picker-empty(v-if="pickerList.length === 0")
          img(src="@/assets/picker-empty.png")
          .tips 暂时没有提货单

    el-dialog(:visible.sync="isShowRefundDialog" width="75%")
      refund-item(:item="refundOrderItem" v-if="isShowRefundDialog")

    update-price(v-model="isShowUpdatePrice" :item="orderDetail"
      v-if="isShowUpdatePrice" @updateSuccess="getOrderDetail")

    el-dialog(:visible.sync="isShowDelayTime" title="延长订单付款时间" center)
      el-form
        el-form-item(label="选择订单延长时间")
          el-select.w-150(v-model="delayTime" placeholder="选择订单延长时间" size="small")
            el-option(label="延长1小时" :value="1")
            el-option(label="延长3小时" :value="3")
            el-option(label="延长5小时" :value="5")
            el-option(label="延长8小时" :value="8")
            el-option(label="延长24小时" :value="24")
            el-option(label="延长48小时" :value="48")
      p 延长后将在{{delayAfterTime()}}后取消
      .hint 提示：延长后订单的付款时间将会延长
      .dialog-footer(slot="footer")
        el-button(@click="isShowDelayTime = false") 取 消
        el-button(type="primary" @click="confirmDelayTime") 确 认

    el-dialog(:visible.sync="isShowSellerMemo" title="添加备注" center)
      el-input(type="textarea" :rows="5" maxlength="50" placeholder="可以输入50个字的备注"
        v-model="remark" show-word-limit)
      .hint 该备注仅自己可见
      .dialog-footer(slot="footer")
        el-button(@click="isShowSellerMemo = false") 取 消
        el-button(type="primary" @click="confirmSellerMemo") 确 认


    zg-nav-bar.p-20(style="position:fixed;top:25%;right:20px;" :menus="menus")
    real-name-verify(:visible.sync="showVerify" :showRange="showRange" @close="showRange = 0")
    contract-history(:visible.sync="showContractHistory" :history="contractHistory" @view-contract="downloadContract" @sign-contract="goToSign" :can-sign="!['CLOSED', 'CANCEL'].includes(orderMainInfo.orderStatus) && (orderDetail && orderDetail.orgInfo && !orderDetail.orgInfo.isSelfOrg) && orderDetail.bizOrder.subBizType !== 100")
    batch-import(:visible.sync="isShowBatchImport" :order-id="orderId" @loopSuccess="getOrderDetail")
    import-guide(v-if="isShowGuide" :guide-refs="guideRefs" @hideGuide="hideGuide")
    changeBundleNo(:visible.sync="showChangeBundleNo" :updateBundleInfo="updateBundleInfo" @fetch="handleFetch")
</template>

<script>
import refundItem from './components/orderRefundItem.vue'
import PickerSection from '../picker/components/picker-section.vue'
import UncertainOrderList from './components/uncertainOrderList'
import { FILE_ACCESS_PRIVATE, ZM_ROOT, RECEIVE_MODE } from '@/common/constants/'
import { getWebToken } from '@/common/utils/common'
import updatePrice from './components/updatePrice'
import Countdown from './components/countdown'
import Clipboard from 'clipboard'
import ModuleTitle from '@/components/module-title'
import ZgButton from '@/components/zg-button'
import ZgStep from '@/components/zg-step'
import TitleItem from '@/pages/picker/components/picker-section-title-item'
import ZgNavBar from '@/components/zg-navbar'
import NP from 'number-precision'
import { dataFormat } from '@/common/filters'
import ZgInfo from '@/components/zg-info'
import RealNameVerify from '@/components/sign/info-verify'
import { CONTRACT_STATUS } from '@/common/constants/index'
import ContractHistory from './components/contractHistory'
import BatchImport from './components/batchImport'
import ImportGuide from './components/importGuide'
import { getIsAbleEditGoods } from './helper'
import changeBundleNo from './components/changeBundleNo'
import cloneDeep from 'lodash/cloneDeep'
import InvoiceDayTip from '@/components/invoiceDayTip.vue'

export default {
  components: {
    InvoiceDayTip,
    ModuleTitle,
    refundItem,
    PickerSection,
    updatePrice,
    Countdown,
    ZgButton,
    ZgStep,
    TitleItem,
    ZgNavBar,
    UncertainOrderList,
    ZgInfo,
    RealNameVerify,
    ContractHistory,
    BatchImport,
    ImportGuide,
    changeBundleNo
  },
  RECEIVE_MODE,
  data() {
    return {
      updateBundleInfo: {},
      showChangeBundleNo: false,
      invoiceDetail: {},
      orderMainInfo: {},
      orderDetail: {},
      logisticsOrder: {},
      payOrderInfoList: [],
      payInfoList: [],
      suborderList: [],
      pickerList: [],
      activeStep: 0,
      isShowRefundDialog: false,
      refundOrderItem: {},
      isShowUpdatePrice: false,
      isShowDelayTime: false,
      isShowSellerMemo: false,
      isShowBatchImport: false,
      delayTime: 1,
      remark: '',
      shareLink: '',
      menus: [
        { label: '订单概览', value: '#overview' },
        { label: '开票信息', value: '#invoice-info' },
        { label: '发票邮寄地址', value: '#picket-address' },
        { label: '收款明细', value: '#pay-info' },
        { label: '商品明细', value: '#goods-info' },
        { label: '提货明细', value: '#pick-info' }
      ],
      picketAddressLs: [],
      isShowAllAddrss: false,
      showVerify: false,
      showRange: 0,
      showContractHistory: false,
      contractHistory: [],
      CONTRACT_STATUS,
      isShowGuide: false,
      guideRefs: []
    }
  },
  computed: {
    isEnableBatchImport() {
      let { suborderList } = this
      if (suborderList && suborderList.length) {
        return suborderList.some(row =>
          getIsAbleEditGoods(row.assignOrderDTO.assignOrderItemList, row.bizOrder.orderStatus)
        )
      } else {
        return false
      }
    },
    orderId() {
      return this.$route.params.id
    },
    // 0普通订单 100工程订单 200不定规格订单
    getOrderType() {
      const { subBizType } = this.orderMainInfo
      if (subBizType === 0) {
        return 'normal'
      } else if (subBizType === 100) {
        return 'project'
      } else if (subBizType === 200) {
        return 'uncertain'
      }
      return ''
    },
    // 是否显示实付款（买家已付款或可付款）
    getIsShowActualPaidFee() {
      const { orderStatus } = this.orderMainInfo
      return !['CLOSED', 'CANCEL'].includes(orderStatus)
    },
    // 买家实付款金额
    getActualPaidFee() {
      if (this.getIsShowActualPaidFee) {
        const { actualTotalFee, paidAmount } = this.orderMainInfo
        return paidAmount
      } else {
        return 0
      }
    }
  },
  async mounted() {
    this.queryDispatchOrdersForSeller()
    await this.getOrderDetail()
    // 如果是不定规格商品并且非待付款状态显示操作按钮
    if (this.getOrderType === 'uncertain' && this.orderMainInfo.orderStatus !== 'WAITING_PAY') {
      this.getGuide()
    }
  },
  methods: {
    handleFetch() {
      this.getOrderDetail()
    },
    updateBizOrderDetailBundleNo(row) {
      this.updateBundleInfo = cloneDeep(row)
      this.showChangeBundleNo = true
    },
    toogleExpand(row) {
      this.refundOrderItem = row
      this.isShowRefundDialog = true
    },
    async getGuide() {
      const result = await this.$get('trademanager.guidePage', {
        pageValue: 1
      })
      if (result.success) {
        if (result.data[0].value) {
          // 展示批量导入
          // 获取dom高度
          this.showGuide()
        }
      }
    },
    showGuide() {
      let { $refs: refs } = this
      let elMain = document.querySelector('.el-main')
      let scrollTop = elMain.scrollTop
      // 获取不定规格组的位置信息，直接可滚动到此位置
      let offsetTop = refs.goodInfo && refs.goodInfo.offsetTop
      elMain.scrollTop = offsetTop
      // 完成引导的按钮的位置
      let confirmBtn =
        refs.uncertainOrderList &&
        refs.uncertainOrderList.$el &&
        refs.uncertainOrderList.$el.querySelector('.confirm-btn')
      // 用来获取位置的dom，用来引导设置按钮的位置
      this.guideRefs = [refs.guide1, refs.guide2, refs.guide3, confirmBtn]
      this.isShowGuide = true
    },
    async hideGuide() {
      this.isShowGuide = false
      let result = await this.$post('trademanager.addGuidePageData', {
        pageValue: 1
      })
    },
    downloadContract(outKey = '') {
      try {
        let key
        if ([CONTRACT_STATUS.BOTH_SIGNED.key].includes(this.orderDetail.detailStatus)) {
          key = this.orderDetail.outContractFileKey
        } else {
          key = this.orderDetail.downloadContractKey
        }
        if (outKey) key = outKey
        if (!key) {
          this.$alert('合同正在生成中，请耐心等待。', '提示', {
            confirmButtonText: '确定',
            callback: () => {
              this.getOrderDetail()
            }
          })
        }
        let downloadElement = document.createElement('a')
        downloadElement.href = `${FILE_ACCESS_PRIVATE}${key}&_tk=${getWebToken()}`
        document.body.appendChild(downloadElement)
        downloadElement.click()
        window.URL.revokeObjectURL(`${FILE_ACCESS_PRIVATE}${key}&_tk=${getWebToken()}`)
        document.body.removeChild(downloadElement)
      } catch (err) {
        console.log(err)
      }
    },
    downloadBankReceipt(receipt) {
      try {
        if (receipt) {
          let downloadElement = document.createElement('a')
          downloadElement.href = `${FILE_ACCESS_PRIVATE}${receipt}&_tk=${getWebToken()}`
          document.body.appendChild(downloadElement)
          downloadElement.click()
          window.URL.revokeObjectURL(`${FILE_ACCESS_PRIVATE}${receipt}&_tk=${getWebToken()}`)
          document.body.removeChild(downloadElement)
        }
      } catch (err) {
        console.log(err)
      }
    },
    /** 获取订单详情 */
    async getOrderDetail(notNeedLoading) {
      const result = await this.$get(
        'trademanager.queryBizOrderForSeller',
        {
          bizOrderId: this.$route.params.id,
          sellerId: this.$store.state.user.userCurrentOrg.id
        },
        { notNeedLoading }
      )
      if (result.success) {
        this.orderDetail = result.data[0].mainOrder
        this.invoiceDetail = result.data[0].invoiceDetail
        this.logisticsOrder = result.data[0].logisticsOrder
        this.orderMainInfo = this.orderDetail && this.orderDetail.bizOrder
        this.remark = this.orderDetail.sellerMemo
        if (
          this.orderMainInfo.orderStatus !== 'CLOSED' &&
          this.orderMainInfo.orderStatus !== 'CANCEL' &&
          this.orderMainInfo.orderStatus !== 'WAITING_PAY'
        ) {
          this.payOrderInfoList = result.data[0].payOrderInfoList || []
        }
        this.payInfoList = []
        this.payOrderInfoList &&
          this.payOrderInfoList.forEach(item => {
            this.payInfoList = this.payInfoList.concat(item.payOrderDetailInfos || [])
          })
        if (
          result.data[0].payOrderInfoList &&
          result.data[0].payOrderInfoList[0].viewCode &&
          result.data[0].payOrderInfoList[0].cmbPay
        ) {
          this.shareLink = `${location.protocol}${ZM_ROOT}/share/order?payChannelType=CMB&viewCode=${result.data[0].payOrderInfoList[0].viewCode}`
        }
        let suborderList = JSON.parse(
          JSON.stringify((this.orderDetail && this.orderDetail.detailOrders) || [])
        )
        suborderList.forEach(item => {
          item.skuTitleList = (item.skuTitleListJson && JSON.parse(item.skuTitleListJson)) || []
          let bizOrder = item.bizOrder
          if (!bizOrder) {
            bizOrder = {}
          }
          if (!bizOrder.processFee) {
            bizOrder.processFee = 0
          }
          if (!bizOrder.storageFee) {
            bizOrder.storageFee = 0
          }
          if (!bizOrder.commissionFee) {
            bizOrder.commissionFee = 0
          }
          if (!bizOrder.promiseInterestSubsidyFee) {
            bizOrder.promiseInterestSubsidyFee = 0
          }
          if (!bizOrder.settleAdjustFee) {
            bizOrder.settleAdjustFee = 0
          }
          if (!bizOrder.logisticsPrice) {
            bizOrder.logisticsPrice = 0
          }
        })
        this.suborderList = suborderList
        this.getPicketAddress(this.orderDetail.buyerOrgInfo)
      }
    },
    // 流程时间
    getTimeStr() {
      return {
        createTime: dataFormat((this.orderMainInfo && this.orderMainInfo.createTime) || 0),
        payTime: dataFormat((this.orderMainInfo && this.orderMainInfo.payTime) || 0),
        consignTime: dataFormat((this.logisticsOrder && this.logisticsOrder.consignTime) || 0),
        completionTime: dataFormat((this.orderDetail && this.orderDetail.completionTime) || 0)
      }
    },
    // 购物流程
    getSteps(status) {
      let list = []
      if (status === 'CLOSED' || status === 'CANCEL' || status === 'REFUNDED') {
        list = [
          { title: '提交订单', time: this.getTimeStr().createTime },
          { title: '订单取消', time: this.getTimeStr().completionTime },
          { title: '审核通过' },
          { title: '已关闭', time: this.getTimeStr().completionTime }
        ]
        this.activeStep = 4
      } else if (
        status === 'NO_PAY_WAITING_DELIVERY' ||
        status === 'NO_PAY_WAITING_SHIPPING' ||
        status === 'NO_PAY_WAITING_FINISH'
      ) {
        list = [
          { title: '提交订单', time: this.getTimeStr().createTime, next: '' },
          { title: '已发货', time: this.getTimeStr().consignTime, next: '' },
          { title: '已收货', time: this.getTimeStr().completionTime, next: '' },
          { title: '已完成', time: this.getTimeStr().completionTime, next: '' }
        ]
        if (status === 'NO_PAY_WAITING_FINISH') {
          this.activeStep = 3
        } else if (status === 'NO_PAY_WAITING_SHIPPING') {
          this.activeStep = 2
        } else if (status === 'NO_PAY_WAITING_DELIVERY') {
          this.activeStep = 1
        }
      } else {
        list = [
          { title: '提交订单', time: this.getTimeStr().createTime },
          { title: '待发货', time: this.getTimeStr().payTime },
          { title: '已发货', time: this.getTimeStr().consignTime },
          { title: '已收货', time: this.getTimeStr().completionTime },
          { title: '已完成', time: this.getTimeStr().completionTime }
        ]
        if (status === 'FINISH') {
          this.activeStep = 5
        } else if (status === 'SHIPPING') {
          this.activeStep = 3
        } else if (status === 'WAITING_DELIVERY') {
          this.activeStep = 2
        } else if (status === 'WAITING_PAY') {
          this.activeStep = 1
        }
      }
      return list
    },
    async queryDispatchOrdersForSeller(orderId) {
      const result = await this.$post('lgcenter.queryDispatchOrdersForSeller', {
        queryDispatchOrdersForSeller: {
          orderId: this.$route.params.id,
          pageSize: 1000
        }
      })
      if (result.success) {
        this.pickerList = result.data[0].data || []
      }
    },
    onTimeEnd() {
      let count = 0
      let timeId = setInterval(() => {
        count++
        this.getOrderDetail(true)
        if (this.orderMainInfo.orderStatus !== 'WAITING_PAY' || count > 10) {
          clearInterval(timeId)
        }
      }, 2000)
    },
    /** 确认延长订单付款时间 */
    async confirmDelayTime() {
      try {
        const result = await this.$post('trademanager.delayOrderPayTimeForSeller', {
          bizOrderId: this.orderMainInfo.bizOrderId,
          delayType: this.delayTime
        })
        if (result.success) {
          if (result.data[0].value) {
            this.$message.success('订单付款时间延长成功')
            this.isShowDelayTime = false
            this.getOrderDetail()
          } else {
            this.$message.error('订单付款时间延长失败')
          }
        }
      } catch (err) {
        console.log(err)
      }
    },
    /** 确认添加订单备注 */
    async confirmSellerMemo() {
      try {
        const result = await this.$post('trademanager.createOrderRemarkForSeller', {
          bizOrderId: this.orderMainInfo.bizOrderId,
          remark: this.remark
        })
        if (result.success) {
          if (result.data[0].value) {
            this.$message.success('添加订单备注成功')
            this.isShowSellerMemo = false
            this.remark = ''
            this.getOrderDetail()
          } else {
            this.$message.error('添加订单备注失败')
          }
        }
      } catch (err) {
        console.log(err)
      }
    },
    delayAfterTime() {
      let result = 0
      if (this.orderDetail) {
        let ss = this.orderDetail.bizOrderPayTimeOut + this.delayTime * 3600
        let hh = Math.floor(ss / 3600)
        let mm = Math.floor((ss - hh * 3600) / 60)
        ss = ss - hh * 3600 - mm * 60
        result = `${hh}小时${mm}分钟${ss}秒`
      }
      return result
    },
    /** 点击复制 */
    sharePayInfo() {
      let clipboard = new Clipboard('.copy-pay-info')
      clipboard.on('success', () => {
        this.$message.success('复制成功')
        clipboard.destroy()
      })
      clipboard.on('error', () => {
        // 不支持复制
        this.$message.warning('该浏览器不支持自动复制')
        clipboard.destroy()
      })
    },
    toChat(id) {
      window.IM &&
        window.IM.show({
          sessionId: id
        })
    },
    /** 获取发票邮寄地址 */
    async getPicketAddress(org) {
      const theUserId = (org && org.id) || ''
      if (theUserId) {
        try {
          const result = await this.$post('user.getOrgAddressByOrgId', {
            theUserId
          })
          if (result.success) {
            this.picketAddressLs = result.data[0].value || []
          }
        } catch (err) {
          console.log(err)
        }
      }
    },
    async goToSign() {
      let { contractNo, contractVersion } = this.orderDetail
      let param = {
        contractNo,
        contractVersion,
        source: 2,
        returnUrl: window.location.href,
        expireTime: 604800 // 七天
      }
      let { success, data } = await this.$post('contract.sign', { request: param })
      if (success) {
        window.location.href = data[0].url
      } else {
        switch (data.stat.stateList[0].code) {
          case 5015: // 缺少统一社会信用编码
            this.openVerify(1)
            return false
          case 5014: // 缺法人信息
            this.openVerify(2)
            return false
          case 5017: // 都缺
            this.openVerify()
            return false
          case 5007:
            this.$alert('合同正在生成中，请稍后再试。', '提示', {
              confirmButtonText: '确定',
              callback: () => {
                this.getOrderDetail()
              }
            })
            return false
          default:
            this.$message.warning('请稍候再试或者联系管理员')
        }
      }
    },
    openVerify(range = 0) {
      this.showRange = range
      this.showVerify = true
    },
    async viewContractHistory() {
      let {
        success,
        data: [res = {}]
      } = await this.$get('contract.contractHistory', {
        request: { bizId: this.orderMainInfo.bizOrderId }
      })
      if (success) {
        console.log(res)
        if (res.contractV0List && res.contractV0List.length > 0) {
          this.contractHistory = res.contractV0List
          this.showContractHistory = true
        } else {
          this.downloadContract()
        }
      } else {
        this.$message.warning('查询合同失败')
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.order-detail
  margin 10px
  font-size 14px
  position relative

  .close-reason
    margin-top 10px
    font-size 12px
    color #666

  .nav-bar
    width 100px
    font-size 14px
    text-align center
    background #f2f2f2
    height 200px
    position fixed
    top 120px
    left 215px

    li
      height 50px
      line-height 50px
      border-bottom 1px solid #ccc
      &:last-child
        border-bottom 0
    a
      color #333

  .order-info
    flex 1
    margin-left 1px

    .steps
      padding 20px 40px 10px

    .order-status
      padding 20px
.title
  font-size 14px
  background-color rgba(248,248,248,1)
  height 40px
  line-height 40px
  color #333
  padding 0 20px
  display flex
  .left
    flex 1

.goods-info
  .module-right
    position absolute
    right: 0
    top 50%
    transform translateY(-50%)

.money
  color #cd974c
  font-size 15px

.goods-name
  font-size 14px
  color #333
  width 100%
  line-height 1.4
  white-space normal
  overflow hidden
  text-overflow ellipsis
  word-break break-all
  display -webkit-box
  -webkit-line-clamp 2
  -webkit-box-orient vertical

.goods-no
  font-size 12px
  color #999

.row
  padding 8px 0

.part
  border 1px solid rgba(240,240,240,1)
  margin-bottom 20px

.border-b
  border-bottom 0

.base-info
  padding 20px

.picker-empty
  text-align center
  padding 50px 0

  img
    width 100px
    height 100px

  .tips
    margin-top 20px
    color #666

.text-r
  text-align right
.sku-title
  text-align left
  font-size 12px
  line-height 1.4
.mb10
  margin-bottom 10px

.hint
  margin-top 10px
  color #999
  font-size 14px
.operate-btn
  padding 3px 15px
  margin-left 0
  &:focus
    border-color transparent
  &:hover
    border-color transparent
.chat
  font-size 12px
  cursor pointer
.full-right
  flex 1
  text-align right
  font-size 14px
.overview
  padding 30px
  padding-top 0
  border 1px solid #f8f8f8
  color #666
  font-size 12px
  &-title
    margin 0 -30px
.basic-info
  display flex
  .order-main-status
    font-size 28px
    font-weight bold
    color #333333
    padding 20px
  &-container
    flex 1
    padding 20px
    .amount
      font-size 12px
      color #999999
      .price
        font-size 14px
        font-weight bold
        color #333
      .price-focus
        color #cd974c
.order-detail
  & >>> .el-table
    border-top 1px solid #f0f0f0
    border-bottom 1px solid #f0f0f0
    &::before
      display none
    & th.is-leaf, & td
      border none
    & th.is-leaf
      background #F8F8F8
      font-size 12px
      color #999999
  .order-main-status
  .basic-info-container
    flex-shrink 0

.picket-address
  padding-top 15px

.p-0
  padding-top 0

.show-all
  height 30px
  line-height 30px
  text-align center
  background-color #f5f5f5
  i
    font-size 14px
.lh-14
  line-height 1.4

.btn-record
  color #cd974c
  background #f8f8f8
  border-color #f0f0f0
  &:hover
    background #fafafa

.overflow-hidden
  overflow hidden
.max-len
  display inline-block
  width 80px
  overflow hidden
  text-overflow ellipsis
  white-space nowrap
</style>
